import React from 'react';
import BreadcrumbImg from "./assets/Images/nav-bar-bg.jpg";
import "./Breadcrumbs.scss";

const Breadcrumbs = ({ children }) => {
  return (
    <div className="breadcrumbs-container">
      <img
        className="breadcrumbs-img"
        src={BreadcrumbImg}
        alt=""
      />
      <div className="breadcrumbs-content">
        {children}
      </div>
    </div>
  );
};

export default Breadcrumbs;